import BillingForm from '../../pages/ecommerce/Checkout';

const CreateBill = () => {
    return(
        <>
            <BillingForm />
        </>
    );
};

export default CreateBill;